import { reactive, toRefs, ref } from 'vue'
import apiPurchase from '../api/purchase.api'
import { formatTimeHHMMSS } from '../utils'

const state = reactive({
  purchaseList: [],
  filterOptions: {},
  loading: false,
  pagination: ref({
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 0
  }),
  paginationInfoLoading: false,
  newPurchases: 0
})

const getSummary = async (params) => {
  state.paginationInfoLoading = true

  try {
    const { data: { total } } = await apiPurchase.getTotal(params)

    state.pagination.rowsNumber = total
  } catch {
  } finally {
    state.paginationInfoLoading = false
  }
}

export default function usePurchase() {

  const getPurchaseList = async (params) => {
    getSummary(params)
    state.loading = true
    const { data } = await apiPurchase.getList(params)

    state.purchaseList = Object.freeze(data)
    state.filterOptions = params

    state.pagination.page = params?.page ? params.page : 1
    state.pagination.rowsPerPage = params["page-size"] ? params["page-size"] : 100

    state.loading = false
  }

  const updatePurchase = () => {
    const purchaseList = [...state.purchaseList]
    for (let i = 0; i < purchaseList.length; i++) {
      const row = purchaseList[i]
      if (row.status === 'Initialized') {
        console.log("Updating waiting time and amount")
        const currentTime = new Date().getTime()
        const createdAt = new Date(row.createdAt).getTime()
        const waitingTime = Math.floor((currentTime - createdAt))
        const hours = Math.floor(waitingTime / 1000 / 60 / 60)
        const mins = Math.floor(waitingTime / 1000 / 60 % 60)
        const secs = Math.floor(waitingTime / 1000 % 60)

        const totalMins = Math.ceil(waitingTime / 1000 / 60)

        row.waitingTimeParsed = `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
        row.amount = Number((totalMins * row.device.waitingPrice / 60).toFixed(0))
        row.amount = Number(row.amount + (row.energy / 3600000 * row.device.price)).toFixed(0)
        row.parkingAmount = Number((Math.ceil(totalMins * row.device.waitingPrice / 60)).toFixed(0))
      }
    }
    state.purchaseList = purchaseList
  }

  return {
    ...toRefs(state),
    getPurchaseList,
    updatePurchase,
  }
}